const contentData = [
  {
    title: "FileMaker Development",
    link: "https://bevl.ltd/filemaker/",
    description:
      "Using the fastest development platform on the market, FileMaker takes your business from zero to organised in no time. Combine that with our ability to create intuitive applications; and you have a business system that boasts scalability and connectivity."
  },
  {
    title: "Hosting Solutions",
    link: "https://bevl.ltd/hosting/",
    description:
      "Move your business to the cloud, with Bevl. We get your custom-apps up and running in a web-hosted location; where we monitor your usage and make sure everything is running efficiently. We also keep everything up-to-date for you, too!"
  },
  {
    title: "Our Portfolio",
    link: "https://bevl.ltd/portfolio/",
    description:
      "Check out our extensive portfolio that details how we engage with our customers and create custom-built applications for your business that automate mundane tasks and bring context to all areas of your company."
  },
  {
    title: "Our Blog",
    link: "https://bevl.ltd/blog/",
    description:
      "Stay up-to-date with the latest information and news with Bevl by following our blog. We also write articles about trending business information and stories."
  }
];

export default contentData;
